module.exports = __webpack_public_path__ + "img/gifts.1b8b67df.png";